import React, { useState } from 'react';
import { Modal, Spinner } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

type Props = {
    show: boolean;
    setShow: any;
};

const SessionExpired = (props: Props) => {
    const navigate = useNavigate();

    const handleClose = () => {
        props.setShow(false);
    };

    const handleLogOut = () => {
        navigate("/logout");
    };


    return (
        <Modal
            show={props.show}
            // onHide={handleClose}
            bnackdrop="static"
            keyboard={false}
            // dialogClassName={"modal-90w"}
            size={"xl"}
        >
            <Modal.Header closeButton>
                <Modal.Title className="fw-bold text-danger" style={{ fontSize: "2rem" }}>
                    Session Expired
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div>
                    <p className='text-bold'>Session Expired Please logout</p>
                    <button
                        type="submit"
                        className="btn btn-danger mt-3 mx-2 "
                        onClick={handleLogOut}
                    >
                        Logout
                    </button>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default SessionExpired;